import {
    Box,
    Checkbox,
    Chip,
    FormControl,
    FormHelperText,
    Grid,
    Hidden,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';

const gradeArray = [
    'Kindergarten',
    'Prep',
    'Grade 1',
    'Grade 2',
    'Grade 3',
    'Grade 4',
    'Grade 5',
    'Grade 6',
    'Grade 7',
    'Grade 8',
    'Grade 9',
    'Grade 10',
    'Grade 11',
    'Grade 12',
];

export const GradeDropDown = props => {
    const [error, setError] = useState(false);

    const handleGradeChange = event => {
        console.log(
            'typeof ',
            typeof event.target.value,
            JSON.stringify(event.target.value)
        );
        if (
            (event.target.value.filter(
                item =>
                    item.indexOf('Grade 1') !== -1 ||
                    item.indexOf('Grade 2') !== -1 ||
                    item.indexOf('Grade 3') !== -1 ||
                    item.indexOf('Grade 4') !== -1 ||
                    item.indexOf('Grade 5') !== -1 ||
                    item.indexOf('Grade 6') !== -1
            ).length > 0 &&
                props.schoolGrades.includes('PrimarySchool')) ||
            (event.target.value.filter(
                item =>
                    item.indexOf('Grade 7') !== -1 ||
                    item.indexOf('Grade 8') !== -1 ||
                    item.indexOf('Grade 9') !== -1 ||
                    item.indexOf('Grade 10') !== -1 ||
                    item.indexOf('Grade 11') !== -1 ||
                    item.indexOf('Grade 12') !== -1
            ).length > 0 &&
                props.schoolGrades.includes('SecondarySchool')) ||
            (event.target.value.filter(
                item => item.indexOf('Kindergarten') !== -1
            ).length > 0 &&
                props.schoolGrades.includes('Kindergarten')) ||
            (event.target.value.filter(item => item.indexOf('Prep') !== -1)
                .length > 0 &&
                props.schoolGrades.includes('FoundationPrep')) ||
            event.target.value.length === 0
        ) {
            setError(false);
        } else {
            setError(true);
        }
        props.handleGrade(
            // On autofill we get a stringified value.
            typeof event.target.value === 'string'
                ? event.target.value.split(',')
                : event.target.value
        );
    };
    return (
        <Grid
            container
            xs={12}
            sx={{
                marginTop: 1,
                marginBottom: 1,
                display: 'flex',
                justifyContent: props.center ? 'center' : 'initial',
                alignItems: props.center ? 'center' : 'initial',
            }}
        >
            <Hidden only={['xs']}>
                <Grid item xs={12} sm={3} md={5}>
                    <Typography variant="h6">{props.title}:</Typography>
                </Grid>
            </Hidden>
            <Grid item xs={12} sm={6} md={5}>
                {/* <TextField
                    select
                    id="grade"
                    label={props.subtitle}
                    variant="outlined"
                    onChange={handleGradeChange}
                    sx={{ width: '100%' }}
                    helperText={
                        error &&
                        'This teachers skills does align the grade you have selected'
                    }
                >
                    {gradeArray.map((grade, index) => {
                        return (
                            <MenuItem id={index} value={grade}>
                                {grade}
                            </MenuItem>
                        );
                    })}
                </TextField> */}
                <FormControl sx={{ width: '100%' }}>
                    <InputLabel
                        id="demo-multiple-chip-label"
                        sx={{
                            'background-color': 'white',
                            paddingRight: '3px',
                        }}
                    >
                        {props.subtitle}
                    </InputLabel>
                    <Select
                        labelId="grade-list"
                        id="demo-multiple-chip"
                        data-cy="grades"
                        multiple
                        value={props.grade}
                        onChange={handleGradeChange}
                        input={
                            <OutlinedInput
                                id="select-multiple-chip"
                                label="Chip"
                            />
                        }
                        renderValue={selected => (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 0.5,
                                }}
                            >
                                {selected.map(value => (
                                    <Chip key={value} label={value} />
                                ))}
                            </Box>
                        )}
                    >
                        {gradeArray.map((grade, index) => {
                            return (
                                <MenuItem key={index} value={grade}>
                                    <Checkbox
                                        checked={
                                            props.grade.indexOf(grade) > -1
                                        }
                                    />
                                    <ListItemText primary={grade} />
                                </MenuItem>
                            );
                        })}
                    </Select>
                    <FormHelperText>
                        {error &&
                            "This teachers skills doesn't align the grade you have selected"}
                    </FormHelperText>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default GradeDropDown;
